import { NotFound } from "components/Templates/NotFound";
import ComplaintsPage from "pages/Complaints";
import NewComplaintPage from "pages/Complaints/new-complaint";
import LoginPage from "pages/Login";
import RegisterPage from "pages/Login/register";
import ResetPasswordPage from "pages/Login/reset-password";
import PostsPage from "pages/Posts";
import UsersPage from "pages/Users";
import { AuthProvider } from "providers/auth.provider";
import {
  BrowserRouter as Router,
  Route,
  Routes as RoutesList
} from "react-router-dom";
import ProtectedRoute from "_config/routes/ProtectedRoute";
import WithAuth from "_config/routes/WithAuth";
import { LayoutDefault } from "../../layouts/LayoutDefault";
import { Home } from "../../pages/Home";

export const Routes = () => {
  return (
    <Router basename={process.env.PUBLIC_URL}>
      <AuthProvider>
        <RoutesList>
          <Route element={<WithAuth />}>
            <Route path="/newComplaint" element={<ProtectedRoute rolesRequired={[]} />}>
              <Route index element={<NewComplaintPage />} />
            </Route>
            <Route element={<ProtectedRoute rolesRequired={['Administrador', 'Colaborador']} />}>
              <Route path="/" element={<LayoutDefault />}>
                <Route index element={<Home />} />
                <Route path="posts" element={<PostsPage />} />
                <Route path="complaints" element={<ComplaintsPage />} />
                <Route element={<ProtectedRoute rolesRequired={['Administrador']} />}>
                  <Route path="users" element={<UsersPage />} />
                </Route>
              </Route>
            </Route>
            <Route path="*" element={<NotFound />} />
          </Route>
          
          <Route path="login" element={<LoginPage />} />
          <Route path="register" element={<RegisterPage />} />
          <Route path="resetPassword" element={<ResetPasswordPage />} />
          <Route path="*" element={<NotFound />} />          
        </RoutesList>
      </AuthProvider>
    </Router>
  );
};
